import { ChangeDetectorRef, Component, ElementRef, TemplateRef, ViewChild } from '@angular/core';
import { AppServiceService } from '../services/app-service.service';
import { clientService } from '../services/client.service';
import { MessageService } from '../services/message.service';
import { ChatsComponent } from '../components/chats/chats.component';
import { animate, style, transition, trigger } from '@angular/animations';
import { AppCookieService } from '../utils/AppCookieService';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EncryptionService } from '../services/encryption.service';
import { LocalstorageManagerService } from '../services/localstorage-manager.service';
import "amazon-connect-chatjs";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { AudioService } from '../services/audio.service';
import { LocationService } from '../services/location.service';
import { interval, Subscription, switchMap, takeWhile, tap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { SpeechService } from '../services/speech.service';
import { SpeakService } from '../services/speak.service';
declare var $: any;
declare var DATA: any;
declare var connect: any;
interface Message {
  buttons?: any;
  cardData?: { imageUrl: any; title: any; isTrimmed: boolean; isNotEnglish: any; };
  text: string;
  isUser: boolean;
  user: string,
  info: string,
  isTrimmed: boolean;
  isNotEnglish: boolean;
  info_trimmed: any;
  timestamp: any;
  isGoogleMap: any;
  widgetType: any;
  clickedValue?: any;
}


@Component({
  selector: 'app-chatbot',
  templateUrl: './chatbot.component.html',
  styleUrls: ['./chatbot.component.scss']
})

export class ChatbotComponent {
  messages: Message[] = [];
  userInput: string = '';
  showChatBotScreen: boolean = false;
  showWelcomeScreen: boolean = false;
  showScreenValue: string = 'intro'
  isTyping: boolean = false;
  clientConfigurationId: any = DATA.clientConfigurationId;
  clientConfigurationData: any;
  botLanguages: any = [];
  BotDefaultLanguage: any;
  isGoogleTranslation: boolean = false;
  sessionAttributes: any = {};
  liveChatStartTime: any;
  liveChatEndTime: any;
  buttonFlag = false;
  calendarFlag = false;
  intentNames: any;
  firstLoad = true;
  styleSheet: CSSStyleSheet | undefined;
  theme = 'blue';
  isUserIdle = false;
  activateLLM: any = false;
  userIdleTimeout = 900000;
  // userIdleTimeout = 5000;
  userTimeoutFunction: any = null;
  isAccessControl: boolean = false;
  isIntentDetection: boolean = false;
  isMultilingual: boolean = false;
  isObjectDescriptionImage = false;
  isEmailAttachmentImage = false;
  preferredLanguage: string = 'en';
  isVoice: Boolean = false;
  isAttachment: Boolean = false;
  IsPrescriptionAttachment: Boolean = false;
  isEmoji: Boolean = false;
  isChatTranscript: Boolean = false;
  isTranslateToEnglish: Boolean = false;
  baseChatDelayInterval = 500;
  chatDelayInterval = 500;
  introMessage: boolean = false;
  isUserIdleTimeoutExpired = false;
  selectedRating: number = 0;
  hoveredRating: number = 0;
  currentPopover: any;
  isAudioResponse: boolean = false;
  canStoreDataToLocalStorage: boolean = false;
  showDataPrivacyPolicyModel: boolean = false;
  dataType: string = "initial";
  sessionType: string = "initial";
  @ViewChild(ChatsComponent)
  chats!: ChatsComponent;
  @ViewChild('previousChatModal') previousChatModal: any;
  @ViewChild('dataPrivacyModel') dataPrivacyModel: any;
  @ViewChild('chatWindow')
  chatWindowRef!: ElementRef;
  isLiveChatEnabled: boolean = false;
  @ViewChild('customerInfoModal') customerInfoModal: any;
  title: string = '';
  @ViewChild('uploadFileModel') uploadFileModel: any;
  uploadImageModalText = "";
  uploadImageModalTitle = "";
  isEmailAttachment: boolean = false;
  isSendImageToFeaturesAPI: boolean = false;
  uploadImageTriggerText = "";
  isObjectDescriptionAttachment: boolean = false;
  stream: any;
  isLoading = false;
  canChangeStyle = false;
  isFeedbackSubmitted = false;
  razorPayObj: any;
  paymentGatewayTriggerIntent = "";
  razorpay_key: any;
  razorpay_currency: any;
  onlinePayment: boolean = false;
  pdf_id: any;

  clientName: any;
  initialIntent: any = "hello";
  captureForEyeSkinDetection: boolean = false;
  isAskingPhoneToEnter: any;
  isAskingEmailToEnter: any;
  isAskingForAppRating: boolean = false;
  isAskingForAgentFeedbackStarRating: boolean = false;
  makeInputDisabled: boolean = false;
  isListening : boolean = false;
  bot_details:any =  {
    "region": "",
    "lex_version": "",
    "LexBotName": "",
    "LexBotAlias": "",
    "bot_id": "",
    "bot_alias_id": "",
    "locale_id": ""
  }
  @ViewChild('modalWebcamCapture')
  modalWebcamCapture!: TemplateRef<any>;
  errorCount: number = 0;

  constructor(
    private clientService: clientService,
    private messageService: MessageService,
    private appService: AppServiceService,
    private audioService: AudioService,
    private cookies: AppCookieService,
    private modalService: NgbModal,
    private locationService: LocationService,
    private encryptionService: EncryptionService,
    private localstorageManagerService: LocalstorageManagerService,
    private http: HttpClient,
    private cdr: ChangeDetectorRef,
    private speechService: SpeechService,
    private speakService: SpeakService,
  ) {
  }

  fnListening(event:any){
  this.isListening = event
  this.forceScrollDown();
  }
  async ngOnInit() {

    if (environment.production) {
      console.log = () => { };
      console.warn = () => { };
      console.error = () => { };
      // Add other console methods as needed
    }
    this.fetchInitialData();
    let storageInfo = localStorage.getItem("dataPrivacyPolicy");

    // get local storage is asking phone to enter
    let isAskingPhoneToEnter = localStorage.getItem("isAskingPhoneToEnter");

    let isAskingEmailToEnter = localStorage.getItem("isAskingEmailToEnter");

    if (isAskingPhoneToEnter == "true") {
      this.isAskingPhoneToEnter = true;
    } else {
      this.isAskingPhoneToEnter = false;
    }

    if (isAskingEmailToEnter == "true") {
      this.isAskingEmailToEnter = true;
    } else {
      this.isAskingEmailToEnter = false;
    }

    // logic to check if the data privacy policy is accepted or not
    if (storageInfo) {
      let decryptedData = this.encryptionService.decryptData(storageInfo, "dataPrivacyPolicy");
      if (decryptedData == "accepted") {
        this.showDataPrivacyPolicyModel = false;
        this.canStoreDataToLocalStorage = true;
      } else if (decryptedData == "rejected") {
        this.canStoreDataToLocalStorage = false;
        this.showDataPrivacyPolicyModel = false;
      }
    } else {
      this.canStoreDataToLocalStorage = false;
      // this.showDataPrivacyPolicyModel = true;
      this.DataPrivacyPolicy(true)
    }

    this.fnStartUserIdleTimer()
    const position: any = await this.locationService.getCurrentLocation();
    console.log(position);
  }


  reciveChatBotScreenValue(event: boolean) {
    this.showChatBotScreen = event;
    this.showWelcomeScreen = false;

    if (this.clientConfigurationData.IsContextRemembrance == true) {
      let previousChats = this.fnGetPreviousChats();
      if (previousChats && previousChats.length > 3) {
        this.fnOpenPreviousChatModal(this.previousChatModal);
      }
    }
  }

  handleListenChangeEvent(event: any) {

    if (event == "payment") {
      this.isTyping = true;
      const itemToPush = {
        isUser: false,
        user: 'me',
        text: 'Please proceed with the payment to complete the booking.',
        // buttons: allButton,
        timestamp: this.fnGetDate(),
        isNotEnglish: true,
        widgetType: 'input_message',
        info: '',
        isTrimmed: false,
        info_trimmed: undefined,
        isGoogleMap: undefined
      }

      this.messages.push(itemToPush);
      this.forceScrollDown();

      // add to local storage
      this.handleStoreChatToLocalStorage(itemToPush)

      setTimeout(() => {
        const itemToPush = {
          isUser: false,
          user: 'me',
          text: '',
          // buttons: allButton,
          timestamp: this.fnGetDate(),
          isNotEnglish: true,
          widgetType: 'payment',
          info: '',
          isTrimmed: false,
          info_trimmed: undefined,
          isGoogleMap: undefined
        };

        this.messages.push(itemToPush);
        this.forceScrollDown();

        // add to local storage
        this.handleStoreChatToLocalStorage(itemToPush);
        this.isTyping = false;
      }, 1000);






      return
    }

    this.showScreenValue = event;
  }

  // ! intial data fetch
  fetchInitialData() {
    this.clientService.getClientData({ ClientConfigurationId: this.clientConfigurationId }).subscribe({
      next: (res) => {
        if (res) {



          this.clientConfigurationData = res
           DATA.bot_details =  {
            "region": this.clientConfigurationData.region || "us-east-1",
            "lex_version": this.clientConfigurationData.lex_version || "v1",
            "LexBotName": this.clientConfigurationData.LexBotName ,
            "LexBotAlias": this.clientConfigurationData.LexBotAlias,
            "bot_id": this.clientConfigurationData.bot_id,
            "bot_alias_id": this.clientConfigurationData.bot_alias_id,
            "locale_id": this.clientConfigurationData.locale_id
          }
          this.showChatBotScreen = this.clientConfigurationData.IsWelcomeScreenDisabled;
          this.showWelcomeScreen = !this.clientConfigurationData.IsWelcomeScreenDisabled;

          this.botLanguages = this.clientConfigurationData.BotLanguages === "" ? [{"name":"English","value":"en"}] : JSON.parse(this.clientConfigurationData.BotLanguages);
          this.BotDefaultLanguage = this.clientConfigurationData.BotDefaultLanguage;
          this.isGoogleTranslation = this.clientConfigurationData.IsGoogleTranslation
          this.isVoice = this.clientConfigurationData.IsVoice == 1 ? true : false;
          this.isAttachment = this.clientConfigurationData.IsAttachment == 1 ? true : false;
          this.IsPrescriptionAttachment = this.clientConfigurationData.isPrescriptionAttachment == 1 ? true : false;
          this.isEmoji = this.clientConfigurationData.IsEmoji == 1 ? true : false;
          this.isMultilingual = this.clientConfigurationData.IsMultilingual == 1 ? true : false;
          this.isIntentDetection = this.clientConfigurationData.IsIntentDetection == 1 ? true : false;
          this.isAccessControl = this.clientConfigurationData.IsAccessControl == 1 ? true : false;
          this.isChatTranscript = this.clientConfigurationData.IsChatTranscript == 1 ? true : false;
          this.isTranslateToEnglish = this.clientConfigurationData.IsTranslateToEnglish == 1 ? true : false;
          this.title = this.clientConfigurationData.Title;
          this.initialIntent = this.clientConfigurationData.UserFormTriggerText || this.initialIntent;

          //setting Data for global variable
          DATA.website_Url = this.clientConfigurationData.website_Url
          DATA.lexBotAlias = this.clientConfigurationData.lexBotAlias
          DATA.title = this.clientConfigurationData.Title;
          DATA.lexPoolId = this.clientConfigurationData.LexPoolId;
          DATA.lexBotName = this.clientConfigurationData.LexBotName;
          DATA.lexBotAlias = this.clientConfigurationData.LexBotAlias;
          DATA.theme = this.clientConfigurationData.Theme;
          DATA.avatarUrl = this.clientConfigurationData.AvatarUrl;
          DATA.logoUrl = this.clientConfigurationData.LogoUrl;
          DATA.welcomeImageUrl = this.clientConfigurationData.WelcomeImageUrl;
          DATA.LanguageDropDownBackgroundColor = this.clientConfigurationData.LanguageDropDownBackgroundColor;
          DATA.LanguageDropDownextColor = this.clientConfigurationData.LanguageDropDownextColor;

          DATA.position = this.clientConfigurationData.BotPosition;
          DATA.size = this.clientConfigurationData.BotLayoutSize;
          this.clientName = this.clientConfigurationData.ClientName;

          DATA.welcomeMessageHeading = this.clientConfigurationData.WelcomeMessageHeading;
          DATA.welcomeMessageData = this.clientConfigurationData.WelcomeMessageData;
          DATA.termsConditionMessage = this.clientConfigurationData.TermsConditionMessage;
          DATA.quickReplies = this.clientConfigurationData.quickReplies === "" ? [] : JSON.parse(this.clientConfigurationData.QuickReplies);
          DATA.launchMessage = this.clientConfigurationData.LaunchMessage;
          DATA.primaryColor = this.clientConfigurationData.PrimaryColor;
          DATA.secondaryColor = this.clientConfigurationData.SecondaryColor;
          DATA.tertiaryColor = this.clientConfigurationData.TertiaryColor;
          DATA.gradientColor1 = this.clientConfigurationData.GradientColor1;
          DATA.gradientColor2 = this.clientConfigurationData.GradientColor2;
          DATA.source = this.clientConfigurationData.Source;

          //Live chat
          DATA.isStartLiveChat = this.clientConfigurationData.isStartLiveChat;
          DATA.LiveChatTriggerResponse = this.clientConfigurationData.LiveChatTriggerResponse;
          DATA.LiveChatBackendURL = this.clientConfigurationData.LiveChatBackendURL;
          DATA.LiveChatContactFlowId = this.clientConfigurationData.LiveChatContactFlowId;
          DATA.LiveChatInstanceId = this.clientConfigurationData.LiveChatInstanceId;
          DATA.LiveChatRegion = this.clientConfigurationData.LiveChatRegion;
          this.isLiveChatEnabled = this.clientConfigurationData.IsLiveChat;
          this.isSendImageToFeaturesAPI = !this.clientConfigurationData.IsImageRecognition;



          //Context Remembrance
          DATA.IsContextRemembrance = this.clientConfigurationData.IsContextRemembrance == 1 ? true : false;
          this.isObjectDescriptionAttachment = !this.clientConfigurationData.IsImageRecognition;


          this.razorpay_key = this.clientConfigurationData.razorpay_key;
          this.razorpay_currency = this.clientConfigurationData.razorpay_currency;
          this.paymentGatewayTriggerIntent = this.clientConfigurationData.PaymentGatewayTriggerResponse;

          if (this.clientConfigurationData.PrimaryColor && this.clientConfigurationData.PrimaryColor != "" && this.clientConfigurationData.SecondaryColor && this.clientConfigurationData.SecondaryColor != "") {
            this.canChangeStyle = true;
            this.fnSetStyles();
          } else {
            this.fnSetDefaultStyles();
          }

          if (this.IsPrescriptionAttachment == true && res.intentName == null) {
            this.uploadImageModalTitle = "Upload Prescription";
            this.uploadImageModalText = "Click here to select a clear picture of your prescription (Max. size: 10MB)";
            this.isEmailAttachment = true;
            this.isSendImageToFeaturesAPI = true;
            this.uploadImageTriggerText = "Please upload a clear picture of your prescription using the upload button";
          }


          if (this.showDataPrivacyPolicyModel) {
            this.fnOpenModal(this.dataPrivacyModel, {
              centered: true,
              size: 'sm',
              backdrop: "static",
              keyboard: true,
              scrollable: false,
              windowClass: 'rounded-modal'
            });
          }


          if (DATA.IsContextRemembrance == true) {
            let previousChats = this.fnGetPreviousChats();
            if (previousChats && previousChats.length > 3) {
              this.fnOpenPreviousChatModal(this.previousChatModal);
            } else {
              localStorage.removeItem("previousChats-" + DATA.clientConfigurationId);
              localStorage.removeItem("sessionAttributes-" + DATA.clientConfigurationId);
              this.fnGetResponse(this.initialIntent);
            }
          } else {
            this.fnStartNewChat();
            // this.fnGetResponse(this.initialIntent);

          }
         

        }


      },
      error: (e) => {
      },
      complete() {

      },
    })

  }

  handleChangeLanguage(event: any) {
    console.log("onLanguageChange", this.sessionAttributes)
    if (this.sessionAttributes?.leadFormSubmitted == "false") {
      this.fnGetResponse(this.initialIntent);
    } else {
      this.fnGetResponse("main menu");
    }
    //alert(event)
    //   console.log("event123", event);
    //   //localStorage.removeItem("previousChats-" + DATA.clientConfigurationId);
    //  // localStorage.removeItem("sessionAttributes-" + DATA.clientConfigurationId);

    //  // this.messages = [];
    //   this.preferredLanguage = event?.value || "en";



    this.forceScrollDown()
  }

  fnSetStyles() {
    let style = document.createElement("style");
    style.appendChild(document.createTextNode(""));
    document.head.appendChild(style);
    this.styleSheet = style.sheet as CSSStyleSheet;

    this.styleSheet.insertRule(`body{
      color: `+ DATA.primaryColor + `!important;
    }`);

    this.styleSheet.insertRule(`.modal-title{
      color: `+ DATA.primaryColor + `!important;
    }`);

    this.styleSheet.insertRule(`.continue_btn{
      color: ${DATA.primaryColor} !important;
    border: 1px solid ${DATA.primaryColor} !important;
    }`);

    this.styleSheet.insertRule(`.start_new {
      background-color: `+ DATA.primaryColor + `!important;
      color: `+ '#ffffff' + `!important;
    }`);

    this.styleSheet.insertRule(`.uploaded-button {
      background-color: `+ DATA.primaryColor + `!important;
      color: `+ '#ffffff' + `!important;
    }`);


    this.styleSheet.insertRule(`.upload-button:hover {
      background-color: `+ DATA.primaryColor + `!important;
      color: `+ '#ffffff' + `!important;
    }`);

    this.styleSheet.insertRule(`.rating-container {
      background-color: `+ DATA.primaryColor + `!important;
    }`);

    this.styleSheet.insertRule(`.button-box:hover {
      background-color: `+ DATA.primaryColor + `!important;
      color: `+ '#ffffff' + `!important;
    }`);

    this.styleSheet.insertRule(`.progress-bar {
      background-color: `+ DATA.primaryColor + `!important;
    }`);


    this.styleSheet.insertRule(`.bot-middle-scrren::-webkit-scrollbar{
      width: 5px;
    }`);

    this.styleSheet.insertRule(`.bot-middle-scrren::-webkit-scrollbar-thumb{
      background: `+ DATA.primaryColor + `;
      border-radius: 0px;
    }`);

    this.styleSheet.insertRule(`.bot-middle-scrren::-webkit-scrollbar-track{
      background: #f1f1f1;
      border-radius: 10px;
    }`);

    this.styleSheet.insertRule(`.custlivechatbtn{
      background-color: `+ DATA.primaryColor + `!important;
    }`);

    this.styleSheet.insertRule(`.live-chat-header{
      color: `+ DATA.primaryColor + `!important;
    }`);

  }


  fnSetDefaultStyles() {
    let style = document.createElement("style");
    style.appendChild(document.createTextNode(""));
    document.head.appendChild(style);
    this.styleSheet = style.sheet as CSSStyleSheet;

    this.styleSheet.insertRule(`body{
      color: `+ '#124164' + `!important;
    }`);

    this.styleSheet.insertRule(`.modal-title{
      color: `+ '#124164' + `!important;
    }`);

    this.styleSheet.insertRule(`.continue_btn{
      color: #124164 !important;
    border: 1px solid #124164 !important;
    }`);

    this.styleSheet.insertRule(`.start_new {
      background-color: `+ '#124164' + `!important;
      color: `+ '#ffffff' + `!important;
    }`);

    this.styleSheet.insertRule(`.uploaded-button {
      background-color: `+ '#124164' + `!important;
      color: `+ '#ffffff' + `!important;
    }`);


    this.styleSheet.insertRule(`.upload-button:hover {
      background-color: `+ '#124164' + `!important;
      color: `+ '#ffffff' + `!important;
    }`);

    this.styleSheet.insertRule(`.rating-container {
      background-color: `+ '#124164' + `!important;
    }`);

    this.styleSheet.insertRule(`.button-box:hover {
      background-color: `+ '#124164' + `!important;
      color: `+ '#ffffff' + `!important;
    }`);

    this.styleSheet.insertRule(`.progress-bar {
      background-color: `+ '#124164' + `!important;
    }`);


    this.styleSheet.insertRule(`.bot-middle-scrren::-webkit-scrollbar{
      width: 5px;
    }`);

    this.styleSheet.insertRule(`.bot-middle-scrren::-webkit-scrollbar-thumb{
      background: #043656;
      border-radius: 0px;
    }`);

    this.styleSheet.insertRule(`.bot-middle-scrren::-webkit-scrollbar-track{
      background: #f1f1f1;
      border-radius: 10px;
    }`);


  }

  fnModalFileUploadSuccess($event: any) {
    //Object description api support
    if (this.isObjectDescriptionAttachment == true) {
      this.isObjectDescriptionImage = true;
      this.fnUploadImageToFeaturesAPI($event[0], $event[1]);
      return;
    }
    if (this.isEmailAttachment == true) {
      this.isEmailAttachmentImage = true;
      this.fnUploadImageToFeaturesAPI($event[0], $event[1]);
      return;
    }
    this.onClick($event[0], $event[1], $event[2]);
  }

  fnUploadImageToFeaturesAPI(base64Img: any, base64ImgFullUri: any) {

    this.onClick("", "", null, undefined, base64Img, base64ImgFullUri);
  }

  // ! setting up seession attribute
  fnSetSessionAttributes(isLiveChat = true) {
    this.sessionAttributes.ORGANIZER_TIMEZONE = Intl.DateTimeFormat().resolvedOptions().timeZone;
    this.sessionAttributes.leadChannel = "tina";
    this.sessionAttributes.registrationChannel = "tina";
    this.sessionAttributes.WEBSITE_URL = DATA.website_Url;
    this.sessionAttributes.CleintId = DATA.clientConfigurationId;
    this.sessionAttributes.pdf_id = this.pdf_id;
    this.sessionAttributes.is_appointment_complete = (this.sessionAttributes.is_appointment_complete ? "false" : "true")
    this.sessionAttributes.ConfirmLiveAgent = (this.sessionAttributes.ConfirmLiveAgent ? "false" : "true")
    this.sessionAttributes.languageCode = this.preferredLanguage ? this.preferredLanguage : "en";
  }

  // ! getting response from the API
  fnGetResponse(userQuery: any, base64Img = null, base64Audio = null) {

    if (this.isLiveChat == true && this.isLiveChatEnabled == true) {
      this.session.controller.sendMessage({
        message: userQuery,
        contentType: "text/plain"
      })
      return;
    }
    this.isTyping = true;
    this.fnGetSessionAttributesFromLocalStorage();
    this.fnResetUserIdleTimer();
    if (this.isUserIdleTimeoutExpired == true) {
      this.isUserIdleTimeoutExpired = false;
    }



    let inputText = userQuery;
    let languageDetected = "";
    let isNotEnglish = false;
    let param: any = {
      "userInput": inputText,
      "botAlias": DATA.lexBotAlias,
      "sessionAttributes": this.sessionAttributes,
      "bot_details": DATA.bot_details,
      "features": {
        "authorization": this.isAccessControl,
        "intent_detection": this.isIntentDetection,
        "translation": this.isMultilingual,
        "sentiment_analysis": DATA.IsSentimentAnalysis,
        "sentiment_bth": DATA.IsSentimentBTH,
        "object_description": this.isObjectDescriptionImage,
        "google_translate": this.isGoogleTranslation,
        "email_attachment": this.isEmailAttachmentImage,
        "preferred_language": this.preferredLanguage ? this.preferredLanguage : "en",
        // "CleintId": DATA.clientConfigurationId
      },

      "image": base64Img
    }
    if (base64Audio && base64Audio != null) {
      //this.isTyping = true;
      param = { ...param, ...{ "audio": base64Audio } }
    }

    // if(this.activateLLM) 
    // {
    //   console.log("llm_activted")
    //   this.fnLLMRequest(inputText,"")
    // }
    // else {
    //   console.log("llm_deactivated")
    // }
    this.messageService.getSetMessages(param).subscribe({
      next: (res) => {

        if (res && res.statusCode == 200) {
       
        
          if (res?.body?.intentName == null || res?.body?.intentName == "null" && (res?.body?.dialogState == "Failed" ||
            res?.body?.sessionAttributes?.ConfirmLiveAgent === "true"
          )) {
            console.log('custom call')
          }
          console.log("res intne", res?.body?.intentName);
          console.log("chetan_manual_call", res?.body)
          if (res?.body?.slotToElicit == null) {
            console.log("chetan_manual_call2", res?.body)
            this.activateLLM = true

          }
          else {
            this.activateLLM = false
          }

          if (res?.body?.slotToElicit == 'ApptRating') {
            this.isAskingForAppRating = true;

            const itemToPush = {
              isUser: false,
              user: 'me',
              text: '',
              timestamp: this.fnGetDate(),
              isNotEnglish: true,
              widgetType: 'input_message_feedback',
              info: '',
              isTrimmed: false,
              info_trimmed: undefined,
              isGoogleMap: undefined
            };

            this.isTyping = true;
            this.forceScrollDown();

            setTimeout(() => {
              this.forceScrollDown();

              this.isTyping = true;
            }, 100);

            setTimeout(() => {
              this.isTyping = false;
              this.messages.push(itemToPush);
              this.forceScrollDown();
            }, 2000);
            this.forceScrollDown();
            // add to local storage
          } else {
            if (this.isAskingForAppRating == true) {
              this.isAskingForAppRating = false;
            }
          }



          if (res?.body?.slotToElicit == 'contact_number') {
            this.isAskingPhoneToEnter = true;
            // add this to localstorage
            localStorage.setItem("isAskingPhoneToEnter", "true");
          } else {
            localStorage.setItem("isAskingPhoneToEnter", "false");
            this.isAskingPhoneToEnter = false;
          }

          if (res?.body?.slotToElicit == 'email' || res?.body?.slotToElicit == 'EmailId' || res?.body?.slotToElicit == 'emailid'
          ) {
            this.isAskingEmailToEnter = true;
            // add this to localstorage
            localStorage.setItem("isAskingEmailToEnter", "true");
          }
          else {
            localStorage.setItem("isAskingEmailToEnter", "false");
            this.isAskingEmailToEnter = false;
          }

          if (res?.body?.dialogAction?.type == "ElicitIntent" &&
            res?.body?.dialogAction?.message?.content
          ) {
            this.isTyping = false;
            
            const itemToPush = {
              isUser: false,
              user: 'me',
              text: res?.body?.dialogAction?.message?.content,
              timestamp: this.fnGetDate(),
              isNotEnglish: true,
              widgetType: 'input_message',
              info: '',
              isTrimmed: false,
              info_trimmed: undefined,
              isGoogleMap: undefined
            };

            this.messages.push(itemToPush);
            this.forceScrollDown();

            // add to local storage
            this.handleStoreChatToLocalStorage(itemToPush);

          }

          if (res?.body?.statusCode == 500) {
            this.isTyping = false;

            const itemToPush = {
              isUser: false,
              user: 'me',
              text: "Oops! I’m unable to process your request right now. Please try again in a little while. If the issue continues, don’t hesitate to reach out I’m happy to help!",
              timestamp: this.fnGetDate(),
              isNotEnglish: true,
              widgetType: 'input_message',
              info: '',
              isTrimmed: false,
              info_trimmed: undefined,
              isGoogleMap: undefined
            };

            this.messages.push(itemToPush);
            this.forceScrollDown();

            // add to local storage
            this.handleStoreChatToLocalStorage(itemToPush);
            if (this.errorCount == 0) {
              this.fnGetResponse("main menu")
              this.errorCount++;
            }
            return;
          }

          if (res.body.AudioResponseBase64 != undefined) {
            // push into message of user query
            const itemToPush = {
              isUser: true,
              user: 'me',
              text: res?.body?.transcription,
              timestamp: this.fnGetDate(),
              isNotEnglish: true,
              widgetType: 'input_message',
              info: '',
              isTrimmed: false,
              info_trimmed: undefined,
              isGoogleMap: undefined
            };

            this.messages.push(itemToPush);
            this.forceScrollDown();

            // add to local storage
            this.handleStoreChatToLocalStorage(itemToPush);

          }
          //this.isTyping = false;
          this.fnOnChatResponse(res.body);

          if (res?.body?.intentName == "EW_Get_Recommendations") {

            setTimeout(() => {
              this.isTyping = true;
            }, 1100);

            setTimeout(() => {

              // add button to ask for image capture
              const allButton = [
                {
                  text: "Capture Image",
                  value: "Capture_Image_eye_Skin_Detection",
                  type: "button"
                }
              ];
              const itemToPush1 = {
                isUser: false,
                user: 'me',
                text: '',
                buttons: allButton,
                timestamp: this.fnGetDate(),
                isNotEnglish: true,
                widgetType: "button",
                info: '',
                isTrimmed: false,
                info_trimmed: undefined,
                isGoogleMap: undefined

              }


              this.messages.push(itemToPush1);

              this.forceScrollDown();

              // add to local storage
              this.handleStoreChatToLocalStorage(itemToPush1);



              this.isTyping = false;
            }, 3000);
          }
          //console.log("he he",res?.body.message)
          // if(this.isVoice && inputText==="user details" || inputText==="main menu" ) {
          // }
          // else {
          //   //alert(inputText)
          //    this.speechService.speakText(res?.body.message) 
          // }
    
          

          if (res.body.AudioResponseBase64 != undefined) {
            this.cdr.detectChanges();
            //this.fnOnChatResponse(res.body.message);
            this.audioService.playAudioFromBase64(res.body.AudioResponseBase64);

          }

        }
        else {
          this.isTyping = false;

          const itemToPush = {
            isUser: false,
            user: 'me',
            text: "Oops! I’m unable to process your request right now. Please try again in a little while. If the issue continues, don’t hesitate to reach out I’m happy to help!",
            timestamp: this.fnGetDate(),
            isNotEnglish: true,
            widgetType: 'input_message',
            info: '',
            isTrimmed: false,
            info_trimmed: undefined,
            isGoogleMap: undefined
          };

          this.messages.push(itemToPush);
          this.forceScrollDown();
          // add to local storage
          this.handleStoreChatToLocalStorage(itemToPush);
          if (this.errorCount == 0) {
            this.fnGetResponse("main menu")
            this.errorCount++;
          }
          return;
        }

      },
      error: (e) => {
        // this.isTyping = false;
      },
      complete() {

      },
    })
  }

  // ! modify chat response
  async fnOnChatResponse(data: any) {
    console.log("fnOnChatResponse", data)
    this.cdr.detectChanges();
    let chatMessage: any = {};
    let that = this;
    let genericCard = data.responseCard?.genericAttachments;
    //get Button Options 
    let allButton: any = [];


    // live chat support

    if (this.isLiveChatEnabled == true && (data.dialogState == "Failed" ||
      data.sessionAttributes?.ConfirmLiveAgent === "true"

    )) {
      that.isTyping = false;
      that.fnOpenCustomerInfoModal(that.customerInfoModal, data);
    }



    if (data.intentName == that.paymentGatewayTriggerIntent || true) {

      this.onlinePayment = true;
      this.razorPayObj = {
        razorpay_currency: this.razorpay_currency,
        razorpay_key: this.razorpay_key,
        clientName: this.clientName,
        email: data.sessionAttributes?.EmailId,
        name: data.sessionAttributes?.UserName,
        contact: data.sessionAttributes?.PhoneNumber,
        app_id: data.sessionAttributes?.app_id,
        hospital_id: data.sessionAttributes?.hospital_id,
        patient_id: data.sessionAttributes?.patient_id,
        center_id: data.sessionAttributes?.Centre,
        client_id: data.sessionAttributes?.CleintId
      }
    }

    let textData = this.setMessages(data.message);
    if (textData) {
      this.introMessage = true;
    }

    let isGenericCard: boolean = data.responseCard && data.responseCard.genericAttachments ? true : false;

    console.log("data", data.message);
    console.log("textData", textData);


    if (data.message) {
      textData.forEach((element: any, i: any) => {

        /* Add support for video messages - Start */
        if (element.message || (element.attributes && element.attributes.length > 0)) {
          /* Add support for other line breaks - Start */
          element.message = this.replaceAll(element.message, "\\b", "<br/>");
          element.message = this.replaceAll(element.message, "\\n", "<br/>");
          /* Add support for other line breaks - End */
          chatMessage = {
            isUser: false,
            user: 'me',
            info: element.message,
            buttons: [],
            isVideo: true,
            // isFullChat: true,
            videoAttributes: element.attributes,
            timestamp: this.fnGetDate(),
            isNotEnglish: true,
            widgetType: "intro_videos"
            // info_untrimmed: element,
          }

        } else {

          const googleMapsEmbedRegex = /https:\/\/www\.google\.com\/maps\/embed\?pb=/;

          if (element.match(googleMapsEmbedRegex)) {

            chatMessage = {
              isUser: false,
              user: 'me',
              text: element.trim(),
              buttons: [],
              timestamp: this.fnGetDate(),
              isNotEnglish: true,
              widgetType: "google_map"
            }
          } else {


            /* Add support for other line breaks - Start */
            element = this.replaceAll(element, "\\b", "<br/>");
            element = this.replaceAll(element, "\\n", "<br/>");
            /* Add support for other line breaks - End */
            if ((data.sessionAttributes?.UserName === null || data.sessionAttributes?.UserName === "" || data.slots?.UserName === null) &&
              this.messages.length == 0) {

              chatMessage = {
                isUser: false,
                user: 'me',
                text: element,
                buttons: [],
                timestamp: this.fnGetDate(),
                isNotEnglish: true,
                widgetType: "intro_text"
              }
            }
            else {

              chatMessage = {
                isUser: false,
                user: 'me',
                text: element,
                buttons: [],
                timestamp: this.fnGetDate(),
                isNotEnglish: true,
                widgetType: "input_message"
              }
            }
          }
        }

        if (data.sessionAttributes?.date_picker === 'true') {

          this.makeInputDisabled = true;

          setTimeout(() => {
              this.isTyping = true;
              this.forceScrollDown();
          }, 800);

          setTimeout(() => {

            const itemToPush = {
              isUser: false,
              user: 'me',
              text: "",
              timestamp: this.fnGetDate(),
              isNotEnglish: true,
              widgetType: 'date_picker',
              info: '',
              isTrimmed: false,
              info_trimmed: undefined,
              isGoogleMap: undefined
            };

            that.messages.push(itemToPush);
            this.handleStoreChatToLocalStorage(itemToPush)
            this.isTyping = false;
            this.forceScrollDown();
          }, that.chatDelayInterval + 1000);
        }

        if (i == 0) {
          console.log("chatMessage in i = 0", chatMessage, textData);
          chatMessage.isShowAvatar = true;
          that.messages.push(chatMessage);
          this.handleStoreChatToLocalStorage(chatMessage)
          that.forceScrollDown();

          if (i == textData.length - 1 && !isGenericCard) {
            that.isTyping = false;
          } else {
            that.isTyping = true;
          }
        } else {
          that.isTyping = true;
          that.chatDelayInterval = that.baseChatDelayInterval * i;
          that.fnAddDelayedChatMessage.bind(that)(chatMessage, i, textData, isGenericCard);

        }


      });
    }

    if (data.responseCard && data.responseCard.genericAttachments) {
      let genericCard = data.responseCard.genericAttachments;
      let doctorArray: any = [];
      if (genericCard.length > 0 && data.slotToElicit == 'Doctor_Carousel') {

        genericCard.forEach((element: any) => {
          doctorArray.push(element)

        });
        if (doctorArray.length > 0) {
          this.isTyping = true;

          const itemToPushDoctor = {
            isUser: false,
            user: 'me',
            text: '',
            doctors: doctorArray,
            timestamp: this.fnGetDate(),
            isNotEnglish: true,
            widgetType: "doctor_carousel",
            info: '',
            isTrimmed: false,
            info_trimmed: undefined,
            isGoogleMap: undefined
          }

          setTimeout(() => {
            that.messages.push(itemToPushDoctor);
            this.handleStoreChatToLocalStorage(itemToPushDoctor)
            that.isTyping = false;
            that.forceScrollDown();
          }, 1000);
        }

      }

      if (genericCard) {

        let genericCardCount = genericCard.length;
        let i; let holdarray = [];

        for (i = 0; i < genericCardCount; i++) {
          allButton = allButton.concat(genericCard[i].buttons);
        }


      }


      this.calendarFlag = false;
      this.buttonFlag = false;

      if ((genericCard[0].buttons) && (genericCard[0].buttons.length > 0)) {
        this.isTyping = true;

        if (genericCard[0].imageUrl != undefined && (genericCard[0]?.imageUrl !== null) && (genericCard[0]?.imageUrl.trim() !== '')) {
          that.chatDelayInterval += that.baseChatDelayInterval;
          /* Add support for other line breaks - Start */
          genericCard[0].subTitle = that.replaceAll(genericCard[0].subTitle, "\\b", "<br/>");
          genericCard[0].subTitle = that.replaceAll(genericCard[0].subTitle, "\\n", "<br/>");
          /* Add support for other line breaks - End */
          setTimeout(() => {
            this.messages[this.messages.length - 1].cardData = {
              imageUrl: genericCard[0].imageUrl,
              title: genericCard[0].title,
              isTrimmed: false,
              isNotEnglish: false
              // subTitle: genericCard[0].subTitle
            };
            that.forceScrollDown();
          }, that.chatDelayInterval);

        }
        if ((genericCard[0].subTitle !== null) && (genericCard[0].subTitle !== '')) {
          this.messages[this.messages.length - 1].buttons = [];
          this.buttonFlag = false;
          that.chatDelayInterval += that.baseChatDelayInterval;

          setTimeout(() => {

            that.messages.push({
              isUser: false,
              user: 'me',
              text: genericCard[0].subTitle,
              buttons: [],
              timestamp: this.fnGetDate(),
              isNotEnglish: true,
              widgetType: "input_message",
              info: '',
              isTrimmed: false,
              info_trimmed: undefined,
              isGoogleMap: undefined
            });

            that.forceScrollDown();

          }, that.chatDelayInterval);

        }
        that.chatDelayInterval += that.baseChatDelayInterval;

        setTimeout(() => {
          // data.slotToElicit === 'Doctor' for doctor carousel
          // data.sessionAttributes?.dropdown_picker === 'true' for dropdown picker
          // data.slotToElicit === 'Date' for date picker
          // data.slotToElicit === 'Time' for time picker

          if (data.slotToElicit === 'Date' || data.slotToElicit === 'Time' ||
            data.sessionAttributes?.dropdown_picker === 'true'
          ) {
            that.buttonFlag = false;
          }
          else {
            that.buttonFlag = true;
          }

          let widgetType = this.buttonFlag ? "button" : data.sessionAttributes?.dropdown_picker === 'true' ? "dropdown_picker" : data.slotToElicit

          if (widgetType === 'dropdown_picker') {
            this.makeInputDisabled = true;
          }

          const itemToPush = {
            isUser: false,
            user: 'me',
            text: '',
            buttons: allButton,
            timestamp: this.fnGetDate(),
            isNotEnglish: true,
            widgetType: widgetType,
            info: '',
            isTrimmed: false,
            info_trimmed: undefined,
            isGoogleMap: undefined
          }
          that.messages.push(itemToPush);
          this.handleStoreChatToLocalStorage(itemToPush)

          that.isTyping = false;

          that.forceScrollDown();

        }, that.chatDelayInterval);

      } else {
        that.isTyping = false;

      }

      let productArray: any = [];

      genericCard.forEach((element: any) => {
        if (element.buttons == undefined && element.attachmentLinkUrl != null && element.title != null) {
          productArray.push(element)
        }
      });



      if (productArray.length > 0) {
        this.isTyping = true;

        const itemToPush = {
          isUser: false,
          user: 'me',
          text: '',
          products: productArray,
          timestamp: this.fnGetDate(),
          isNotEnglish: true,
          widgetType: "Product_Crousel",
          info: '',
          isTrimmed: false,
          info_trimmed: undefined,
          isGoogleMap: undefined
        }

        setTimeout(() => {
          that.messages.push(itemToPush);
          this.handleStoreChatToLocalStorage(itemToPush)
          that.isTyping = false;
          that.forceScrollDown();
        }, 1000);
      }





    }

    // Special Fix for event bot
    if (data.intentName == 'AltrusiaEvents_fetchEvents') {
      this.isTyping = true;
      setTimeout(() => {
        this.isTyping = true;
      }, 1000 * (textData.length - 1));
      setTimeout(() => {
        this.isTyping = true;
      }, 1000 * (textData.length - 2));
      let events: any = await this.fnGetEventCarouselData();
      if (events.statusCode == 200) {
        this.isTyping = true;
        let eventData = events.body[0]
        let eventArray: any = [];
        //console.log(eventData.speakers)
        if (eventData.speakers && eventData.speakers.length > 0) {
          this.isTyping = true;
          eventData.speakers.forEach((element: any) => {
            eventArray.push({
              'title': element.name,
              "imageUrl": element.img,
              "link": element.link,
              "company": element.company,
              "experience": element.experience,
              "button_text": "Know More",
            })
          });
          // console.log(events)

          const itemToPush = {
            isUser: false,
            user: 'me',
            text: '',
            speakers: eventArray,
            timestamp: this.fnGetDate(),
            isNotEnglish: true,
            widgetType: "speaker_carousel",
            info: '',
            isTrimmed: false,
            info_trimmed: undefined,
            isGoogleMap: undefined
          }

          setTimeout(() => {
            this.isTyping = true;
            const messageToPush = {
              isUser: false,
              user: 'me',
              text: "Here is the list of all confirmed speakers for the event",
              timestamp: this.fnGetDate(),
              isNotEnglish: true,
              widgetType: 'input_message',
              info: '',
              isTrimmed: false,
              info_trimmed: undefined,
              isGoogleMap: undefined
            };
            that.messages.push(messageToPush);
            that.messages.push(itemToPush);
            this.handleStoreChatToLocalStorage(itemToPush)
            //hat.isTyping = false;
            that.forceScrollDown();

          }, 1000 * (textData.length + 1));
        }

        this.isTyping = true;
        if (eventData.sponsers && eventData.sponsers.length > 0) {

          let sponsersArray: any = [];
          eventData.sponsers.forEach((element: any) => {
            this.isTyping = true;
            sponsersArray.push({
              'title': element.title,
              'img_url': element.img_url,
              "link_url": element.link_url,
              "button_text": "Know More",
            })
          });
          // console.log(events)

          const itemToPush = {
            isUser: false,
            user: 'me',
            text: '',
            sponsors: sponsersArray,
            timestamp: this.fnGetDate(),
            isNotEnglish: true,
            widgetType: "sponsors_carousel",
            info: '',
            isTrimmed: false,
            info_trimmed: undefined,
            isGoogleMap: undefined
          }

          setTimeout(() => {

            this.isTyping = true;
            const messageToPush = {
              isUser: false,
              user: 'me',
              text: "Here is the list of all sponsors for the event",
              timestamp: this.fnGetDate(),
              isNotEnglish: true,
              widgetType: 'input_message',
              info: '',
              isTrimmed: false,
              info_trimmed: undefined,
              isGoogleMap: undefined
            };
            that.messages.push(messageToPush);
            that.messages.push(itemToPush);
            this.handleStoreChatToLocalStorage(itemToPush)
            //hat.isTyping = false;
            that.forceScrollDown();
          }, 1000 * (textData.length + 3));
        }

      }
      setTimeout(() => {

        // add button to ask for image capture
        const allButton = [
          {
            "text": "Speakers",
            "value": "list of all speakers"
          },
          {
            "text": "Sponsors",
            "value": "list of all sponsors"
          },
          {
            "text": "Passes",
            "value": "passes"
          },
          {
            "text": "Contact Us",
            "value": "contact us"
          },
          {
            "text": "About Us",
            "value": "about us"
          },
          {
            "text": "Founders",
            "value": "founders"
          }
        ]
        const itemToPush1 = {
          isUser: false,
          user: 'me',
          text: '',
          buttons: allButton,
          timestamp: this.fnGetDate(),
          isNotEnglish: true,
          widgetType: "button",
          info: '',
          isTrimmed: false,
          info_trimmed: undefined,
          isGoogleMap: undefined

        }

        const messageToPush = {
          isUser: false,
          user: 'me',
          text: "Please click on below buttons to explore the service provided by us.",
          timestamp: this.fnGetDate(),
          isNotEnglish: true,
          widgetType: 'input_message',
          info: '',
          isTrimmed: false,
          info_trimmed: undefined,
          isGoogleMap: undefined
        };
        this.messages.push(messageToPush);
        this.messages.push(itemToPush1);

        this.forceScrollDown();

        // add to local storage
        this.handleStoreChatToLocalStorage(itemToPush1);



        this.isTyping = false;
      }, 1000 * (textData.length + 5));

    }

    this.sessionAttributes = data.sessionAttributes;

    this.fnPushSessionAttributesToLocalStorage();

    // Display Rating Widget for Rating Intent
    if (this.sessionAttributes?.is_appointment_complete == true || this.sessionAttributes?.is_appointment_complete == "true") {
      //that.isTyping = true;
      setTimeout(() => {
        this.fnAddRatingReview();
      }, 1500);
    }

    console.log("this.messages", this.messages);
    console.log("istyping", this.isTyping);
  }

  fnLLMRequest(inputText: any, url: any) {
    let data = {
      "client_id": 1,
      "user_query": inputText
    }
    this.messageService.llmService(data, 'https://vgm44jhg255rsewif2vj3zepwm0icaxi.lambda-url.us-east-1.on.aws').subscribe({
      next: (res: any) => {
        if (res) {
          console.log("res intne", res?.body?.intentName);
          console.log("chetan_manual_call", res?.body)
          if (res?.body?.slotToElicit == null) {
            console.log("chetan_manual_call2", res?.body)
            this.activateLLM = true

          }
          else {
            this.activateLLM = false
          }

          if (res?.body?.dialogAction?.type == "ElicitIntent" &&
            res?.body?.dialogAction?.message?.content
          ) {
            this.isTyping = false;

            const itemToPush = {
              isUser: false,
              user: 'me',
              text: res?.body?.dialogAction?.message?.content,
              timestamp: this.fnGetDate(),
              isNotEnglish: true,
              widgetType: 'input_message',
              info: '',
              isTrimmed: false,
              info_trimmed: undefined,
              isGoogleMap: undefined
            };

            this.messages.push(itemToPush);
            this.forceScrollDown();

            // add to local storage
            this.handleStoreChatToLocalStorage(itemToPush);

          }

          if (res?.body?.statusCode == 500) {
            this.isTyping = false;

            const itemToPush = {
              isUser: true,
              user: 'me',
              text: "Oops! I’m unable to process your request right now. Please try again in a little while. If the issue continues, don’t hesitate to reach out I’m happy to help!",
              timestamp: this.fnGetDate(),
              isNotEnglish: true,
              widgetType: 'input_message',
              info: '',
              isTrimmed: false,
              info_trimmed: undefined,
              isGoogleMap: undefined
            };

            this.messages.push(itemToPush);
            this.forceScrollDown();

            // add to local storage
            this.handleStoreChatToLocalStorage(itemToPush);
            if (this.errorCount == 0) {
              this.fnGetResponse("main menu")
              this.errorCount++;
            }
            return;
          }

          if (res.body.AudioResponseBase64 != undefined) {
            // push into message of user query
            const itemToPush = {
              isUser: true,
              user: 'me',
              text: res?.body?.transcription,
              timestamp: this.fnGetDate(),
              isNotEnglish: true,
              widgetType: 'input_message',
              info: '',
              isTrimmed: false,
              info_trimmed: undefined,
              isGoogleMap: undefined
            };

            this.messages.push(itemToPush);
            this.forceScrollDown();

            // add to local storage
            this.handleStoreChatToLocalStorage(itemToPush);

          }
          //this.isTyping = false;
          this.fnOnChatResponse(res.body);

          if (res?.body?.intentName == "EW_Get_Recommendations") {

            setTimeout(() => {
              this.isTyping = true;
            }, 1100);

            setTimeout(() => {

              // add button to ask for image capture
              const allButton = [
                {
                  text: "Capture Image",
                  value: "Capture_Image_eye_Skin_Detection",
                  type: "button"
                }
              ];
              const itemToPush1 = {
                isUser: false,
                user: 'me',
                text: '',
                buttons: allButton,
                timestamp: this.fnGetDate(),
                isNotEnglish: true,
                widgetType: "button",
                info: '',
                isTrimmed: false,
                info_trimmed: undefined,
                isGoogleMap: undefined

              }


              this.messages.push(itemToPush1);

              this.forceScrollDown();

              // add to local storage
              this.handleStoreChatToLocalStorage(itemToPush1);



              this.isTyping = false;
            }, 3000);
          }

          if (res.body.AudioResponseBase64 != undefined) {
            this.cdr.detectChanges();
            //this.fnOnChatResponse(res.body.message);
            this.audioService.playAudioFromBase64(res.body.AudioResponseBase64);

          }

        }
      },
      error: (e) => {

      }
    })
  }
  //  ! Add Rating and Review
  fnAddRatingReview() {
    let messages = ["That’s great, Happy to be of help !", "On a scale of 1 to 5, with 1 being the lowest and 5 being the highest, how would you rate your overall experience?", "give-feeback"]

    messages.forEach((element: any, i: any) => {
      let wType = "input_message";
      if (i == 2) {
        wType = "input_message_feedback"
      }
      let chatMessage = {
        isUser: false,
        user: 'me',
        text: element,
        buttons: [],
        timestamp: this.fnGetDate(),
        isNotEnglish: true,
        widgetType: wType
      }
      // this.isTyping = true;
      this.chatDelayInterval = this.baseChatDelayInterval * i;
      this.fnAddDelayedChatMessage.bind(this)(chatMessage, i, [], false, true);
    })



  }

  // ! Pushing Session Attributes to cookie storage to get it back on continue previous chat
  fnPushSessionAttributesToLocalStorage() {



    const encryptedData = this.encryptionService.encryptData(this.sessionAttributes, DATA.clientConfigurationId);
    localStorage.setItem("sessionAttributes-" + DATA.clientConfigurationId, encryptedData);
  }

  // ! Get Session Attributes from cookie storage
  fnGetSessionAttributesFromLocalStorage() {
    const sessionAttributes = localStorage.getItem("sessionAttributes-" + DATA.clientConfigurationId);

    if (!sessionAttributes) {
      this.fnSetSessionAttributes();
    } else {
      console.log("cj", sessionAttributes)
      this.sessionAttributes = this.encryptionService.decryptData(sessionAttributes, DATA.clientConfigurationId);
      this.sessionAttributes = this.sessionAttributes;
    }
    this.fnSetSessionAttributes();


  }

  // ! Get current date and time
  fnGetDate() {
    return new Date();
  }
  async fnGetEventCarouselData() {

    return new Promise((resolve, reject) => {
      let param = {
        bot_id: this.clientConfigurationId
      }
      this.appService.getEventData(param).subscribe({
        next: data => {
          resolve(data);
        },
        error: err => {
          reject(err);
        }
      });
    });



  }


  extractUrl(info: string) {
    const urlRegex = /URL:\s*(https?:\/\/[^\s]+)/;
    const match = info.match(urlRegex);

    if (match && match[1]) {
      const extractedUrl = match[1];
      return `URL: <a href="${extractedUrl}" target="_blank"> ${extractedUrl} </a>`;
    }
    return null;
  }

  // ! spliting chat response into array based on ~ 
  setMessages(info: any) {
    let temp1: any[] = [];
    if (info.indexOf('~') === -1) {
      temp1 = [info];
    } else {
      temp1 = info.split('~');
    }
    let isVideoLink = false;
    let videoLinkTag = "";
    // let videoLinks: any[] = [];
    // if (info.includes('#videoLink=')) {
    //   videoLinkTag = "#videoLink=";
    //   isVideoLink = true;
    //   videoLinks = info.split(videoLinkTag);
    // }

    // console.log("videoLinks", videoLinks);

    // let videoLinks: string[] = [];
    // const videoLinkRegex = /#videoLink\s*=\s*['"]([^'"]+)['"]/g;

    // let match;
    // while ((match = videoLinkRegex.exec(info)) !== null) {
    //   videoLinks.push(match[1]);
    // }

    let regex1 = /#videoLink\s*=\s*'([^']+)'/g;


    let regex2 = /#videoLink=&#39;(https:\/\/www\.youtube\.com\/embed\/[^&#39;]+)&#39;/g;


    let match;
    let videoLinks: string[] = [];

    while ((match = regex1.exec(info) ||
      regex2.exec(info)
    ) !== null) {
      videoLinks.push(match[1]); // Extract the video URL from the first capturing group
    }

    console.log("videoLinks", videoLinks);
    console.log("videoLinkLength", videoLinks.length);

    if (videoLinks.length > 0) {
      videoLinkTag = "#videoLink";
      isVideoLink = true;

    }

   



    // let videoLinks: any[] = info.split('#videoLink=');
    let videoAttributes: any[];
    let textToBeReplaced = "";
    let videoTitle = "";
    let videoMessage: any = {};
    if (videoLinks.length > 0) {
      console.log("inside Video Link")
      // videoLinks.shift();
      for (let i = 0; i < temp1.length; i++) {
        console.log("temp1[i]", temp1[i]);
        //Change only the message which contains the video link, leave others.
        if (temp1[i].includes(videoLinkTag)) {
          videoMessage.message = "";
          if (!videoMessage.message) {
            videoMessage.message = "";
          }
          videoMessage.attributes = [];
          videoLinks.forEach(videoLink => {
            videoAttributes = videoLink.split('videoTitle=');
            videoLink = videoAttributes[0];
            videoTitle = videoAttributes[1];
            textToBeReplaced = videoLinkTag + videoLink + 'videoTitle=' + videoTitle;
            videoMessage.message = videoMessage.message.replace(textToBeReplaced, '');
            videoMessage.attributes.push({ videoTitle: this.replaceAll(videoTitle, "'", ""), videoLink: this.replaceAll(videoLink, "'", "") });
            temp1[i] = videoMessage;
          })
        }

      }
    }

    for (let i = 0; i < temp1.length; i++) {
      if (typeof temp1[i] != 'object' && temp1[i].includes('URL:')) {
        let returnVal = this.extractUrl(temp1[i]);
        if (returnVal) {
          temp1[i] = returnVal;
        }
      }
    }
    console.log("temp", temp1);
    return temp1;
  }

  // ! Close Modal
  fnClosePreviousChatModal() {
    this.fnCloseModal();
  }

  // ! Close Modal
  fnCloseModal() {

    if (this.stream) {
      this.stream.getTracks().forEach(function (track: any) {
        track.stop();
      });
    }

    this.currentPopover.close();
  }

  fnUpdateStream(stream: any) {
    this.stream = stream;
  }

  escapeRegExp(string: any) {
    return string.replace(/[.*+\-?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
  }

  replaceAll(str: any, find: any, replace: any) {
    let result = "";
    if (str && str.replace) {
      result = str.replace(new RegExp(this.escapeRegExp(find), 'g'), replace);
    }
    if (result) {
      return result;
    }
    return "";
  }

  // ! listening the user input and calling the response function
  onSubmit(event: any) {

    this.makeInputDisabled = false;

    console.log("event****", event);

    console.log("messages", this.messages);
    console.log("before", this.sessionAttributes)




    const localStorageData = this.localstorageManagerService.getPreviousChatData("previousChats-" + DATA.clientConfigurationId);


    if (event.value && event.value == "Capture_Image_eye_Skin_Detection") {
      this.captureForEyeSkinDetection = true;
      this.fnOpenSmallModal(this.modalWebcamCapture);
      return;
    }

    if (event.value) {

      // checking for last widget type is button of not 
      if (localStorageData && localStorageData.length > 0) {

        const decryptStorageData = this.encryptionService.decryptData(localStorageData, DATA.clientConfigurationId);

        if (decryptStorageData[decryptStorageData.length - 1].widgetType == "button" ||
          decryptStorageData[decryptStorageData.length - 1].widgetType == "Doctor"
        ) {
          decryptStorageData[decryptStorageData.length - 1].clickedValue = event.text;
          const encryptedData = this.encryptionService.encryptData(decryptStorageData, DATA.clientConfigurationId);
          this.localstorageManagerService.setPreviousChatData("previousChats-" + DATA.clientConfigurationId, encryptedData);
        }
      }


      const itemToPush = {
        isUser: true,
        user: 'me',
        text: event.text,
        info: "",
        info_trimmed: "",
        isGoogleMap: "",
        isTrimmed: false,
        timestamp: this.fnGetDate(),
        isNotEnglish: true,
        widgetType: "input_message"
      }
      this.messages.push(itemToPush);
      this.handleStoreChatToLocalStorage(itemToPush)

      this.forceScrollDown();

      if (this.isAskingForAgentFeedbackStarRating) {
        this.isAskingForAgentFeedbackStarRating = false;

        this.isTyping = true;
        setTimeout(() => {
          const itemToPush = {
            isUser: false,
            user: 'me',
            text: "Thank you for sharing your feedback. We truly value your input and appreciate your time. Please feel free to proceed with the options below",
            info: "",
            info_trimmed: "",
            isGoogleMap: "",
            isTrimmed: false,
            timestamp: this.fnGetDate(),
            isNotEnglish: true,
            widgetType: "input_message"
          }
          this.messages.push(itemToPush);
          this.forceScrollDown();
          //Support for local storage
          this.handleStoreChatToLocalStorage(itemToPush)

          this.fnGetResponse("main menu");
        }, 1500);

      } else {
        this.fnGetResponse(event.value)
      }


    }
    else if (event.audio) {
      this.cdr.detectChanges();
      this.isTyping = true;
      this.forceScrollDown();
      this.fnGetResponse("", null, event.audio)
    }
    // else if((event.type && (event.type == "start_rating_input") && (parseInt(event.value) > 0 &&  parseInt(event.value) <= 5))) {
    //   this.fnGetResponse(event.value)
    //   const itemToPush = {
    //    isUser: false,
    //    user: 'me',
    //    text: "Thank you for your Feedback",
    //    info: "",
    //    info_trimmed: "",
    //    isGoogleMap: "",
    //    isTrimmed: false,
    //    timestamp: this.fnGetDate(),
    //    isNotEnglish: true,
    //    widgetType: "input_message"
    //  }

    //  //console.log("after",this.sessionAttributes)
    //   this.messages.push(itemToPush);
    //   this.handleStoreChatToLocalStorage(itemToPush)
    //   this.forceScrollDown();



    // }
    else {

      const itemToPush = {
        isUser: true,
        user: 'me',
        text: event,
        info: "",
        info_trimmed: "",
        isGoogleMap: "",
        isTrimmed: false,
        timestamp: this.fnGetDate(),
        isNotEnglish: true,
        widgetType: "input_message"
      }

      this.messages.push(itemToPush);

      this.handleStoreChatToLocalStorage(itemToPush)
      // this.handleGetChatFromCookies()
      this.forceScrollDown();


      this.fnGetResponse(event)
    }



  }

  fnMakeInputDisabled() {
    this.makeInputDisabled = true;
  }

  fnMakeInputEnabled() {
    this.makeInputDisabled = false;
  }

  // ! Changing the Bot Language
  handleBotLanguageChangeEvent(event: any) {
    this.preferredLanguage = event;
  }

  // ! Storing Item in Local Storage
  handleStoreChatToLocalStorage(chatItem: any) {

    console.log("chatItem", chatItem);

    // checking dataTypeIntial just to store initial data
    if (this.canStoreDataToLocalStorage == false && this.dataType != "initial") {
      return;
    }

    this.dataType = "chat";
    let PreviousChat = [];
    const previousChatsData = this.fnGetPreviousChats();

    if (previousChatsData) {
      PreviousChat = previousChatsData;
    }

    PreviousChat.push(chatItem);

    const encryptedData = this.encryptionService.encryptData(PreviousChat, DATA.clientConfigurationId);
    this.localstorageManagerService.setPreviousChatData("previousChats-" + DATA.clientConfigurationId, encryptedData);
  }


  captureForEyeSkinDetectionResponse(event: any) {

    // remove model 
    this.fnCloseModal();

    // make false the captureForEyeSkinDetection
    this.captureForEyeSkinDetection = false;


    const itemToPush1 = {
      isUser: true,
      user: 'me',
      text: event?.base64Image,
      info: "",
      info_trimmed: "",
      isGoogleMap: "",
      isTrimmed: false,
      timestamp: this.fnGetDate(),
      isNotEnglish: true,
      widgetType: "image_message"

    }

    this.messages.push(itemToPush1);

    this.handleStoreChatToLocalStorage(itemToPush1)

    this.forceScrollDown();

    this.isTyping = true;

    setTimeout(() => {
      const itemToPush = {
        isUser: false,
        user: 'me',
        text: event?.skin_tone_result,
        info: "",
        info_trimmed: "",
        isGoogleMap: "",
        isTrimmed: false,
        timestamp: this.fnGetDate(),
        isNotEnglish: true,
        widgetType: "input_message"

      }

      this.messages.push(itemToPush);

      this.handleStoreChatToLocalStorage(itemToPush)

      this.forceScrollDown();
    }, 1500);

    this.isTyping = true;

    setTimeout(() => {
      const itemToPush = {
        isUser: false,
        user: 'me',
        text: "Recommended Products for your skin",
        info: "",
        info_trimmed: "",
        isGoogleMap: "",
        isTrimmed: false,
        timestamp: this.fnGetDate(),
        isNotEnglish: true,
        widgetType: "input_message"

      }

      this.messages.push(itemToPush);

      this.handleStoreChatToLocalStorage(itemToPush)

      this.forceScrollDown();
    }, 3000);

    this.isTyping = true;


    setTimeout(() => {
      this.isTyping = false;
      const itemToPush = {
        isUser: false,
        user: 'me',
        text: '',
        products: event?.product_recommendations,
        info: "",
        info_trimmed: "",
        isGoogleMap: "",
        isTrimmed: false,
        timestamp: this.fnGetDate(),
        isNotEnglish: true,
        widgetType: "Item_Crousel"

      }

      this.messages.push(itemToPush);

      this.handleStoreChatToLocalStorage(itemToPush)

      this.forceScrollDown();
    }, 4500);


  }


  // ! Get Previous Chats from Local Storage and Decrypt and return
  fnGetPreviousChats() {

    const previousChatDataFromLocalStorage = this.localstorageManagerService.getPreviousChatData("previousChats-" + DATA.clientConfigurationId);

    if (!previousChatDataFromLocalStorage) {
      return [];
    }

    const decryptedData = this.encryptionService.decryptData(previousChatDataFromLocalStorage, DATA.clientConfigurationId);

    return decryptedData;
  }

  // ! Start New Chat
  fnStartNewChat() {
    this.messages = [];
    localStorage.removeItem("previousChats-" + DATA.clientConfigurationId);
    localStorage.removeItem("sessionAttributes-" + DATA.clientConfigurationId);
    this.fnGetResponse(this.initialIntent);
  }

  // ! Clear Previous Chat from Cookies
  fnClearPreviousChats() {
    this.localstorageManagerService.removePreviousChatData("previousChats-" + DATA.clientConfigurationId);
  }

  handleAddImageToChat(event: any) {
    const itemToPush = {
      isUser: true,
      user: 'me',
      text: event,
      info: "",
      info_trimmed: "",
      isGoogleMap: "",
      isTrimmed: false,
      timestamp: this.fnGetDate(),
      isNotEnglish: true,
      widgetType: "image_message"
    }

    this.messages.push(itemToPush);

    this.handleStoreChatToLocalStorage(itemToPush)

    this.forceScrollDown();
  }

  lastSentText = "";
  chatInitiatedByUser = false;

  onClick(textToDisplay: any, textToSend: any, index: any, isRefresh = false, base64Img = null, base64ImgFullUrl = null) {
    if (base64Img) {
      this.fnGetResponse(textToSend, base64Img);
      return;
    }

    //Handle button clicks with a tags
    if (textToSend && textToSend.includes("<a")) {
      let div = document.createElement('div');
      div.innerHTML = textToSend.trim();
      let tags = div.getElementsByTagName("a");
      tags[0].click();
      return;
    }
    this.lastSentText = textToSend;
    let cardData = null;
    if (base64ImgFullUrl) {
      cardData = {
        imageUrl: base64ImgFullUrl
      }
    }

    if (isRefresh == true) {
      this.messages = [];
    }

    this.chatInitiatedByUser = true;
    if (textToDisplay !== '') {
      this.firstLoad = false;
    }
    if ((textToSend.indexOf('http://') !== -1) || (textToSend.indexOf('https://') !== -1)) {
      window.open(textToSend, '_blank');
      return;
    } else {
      if (textToDisplay !== '' || (cardData && cardData.imageUrl)) {
        this.messages.push({
          isUser: true,
          user: 'you',
          info: textToDisplay,
          text: '',
          isTrimmed: false,
          isNotEnglish: false,
          info_trimmed: undefined,
          timestamp: undefined,
          isGoogleMap: undefined,
          widgetType: "input_message"
        });
        //Support for local storage
        this.handleStoreChatToLocalStorage({
          isUser: true,
          user: 'you',
          info: textToDisplay !== '' ? textToDisplay : "Image uploaded",
          cardData: null,
          buttons: [],
          isTrimmed: false,
          timestamp: this.fnGetDate(),
          widgetType: "input_message"
        })
        //Support for Transcript
        this.transcripts.push({
          inputTranscript: textToDisplay,
          botResponse: "",
          timestamp: this.fnGetDate()
        })
      } else {
        //Support for Transcript
        this.transcripts.push({
          inputTranscript: "Hello",
          botResponse: "",
          timestamp: this.fnGetDate().toISOString()
        })
      }
      if (index !== null) {
        this.messages[index].buttons = [];
        this.buttonFlag = false;
      }
      this.fnGetResponse(textToSend, base64Img);

    }
  }
  // **********models start ******
  // ! Open Modal
  fnOpenModal(content: any, _options: any = null) {

    if (this.showWelcomeScreen == true) {
      return;
    }

    let options: any = {
      centered: true,
      size: 'xl',
      backdrop: "static",
      keyboard: true,
      scrollable: false
    }
    if (_options != null) {
      options = _options;
    }
    this.currentPopover = this.modalService.open(content, options);
  }

  fnOpenCustomerInfoModal(content: any, data: any) {
    console.log("data646", data);

    if (data?.sessionAttributes?.UserName != undefined && data?.sessionAttributes?.UserName != null
      && data?.sessionAttributes?.UserName != "") {
      this.customerName = data?.sessionAttributes?.UserName;
      setTimeout(() => {
        this.fnInitLiveChat()
      }, 1000);
    } else {

      this.fnOpenModal(content, {
        centered: true,
        size: 'sm',
        backdrop: "static",
        keyboard: true,
        scrollable: false
      });
    }
  }

  fnCloseCustomerInfoModal() {
    this.fnCloseModal();
  }
  // !open file upload model
  fnOpenFileUploadModel() {
    const content = this.uploadFileModel;
    this.fnOpenModal(content, {
      centered: true,
      size: 'xs',
      backdrop: "static",
      keyboard: true,
      scrollable: false
    });
  }

  fnCloseUploadFileModal() {
    if (this.currentPopover) {
      this.currentPopover.close();
    }
  }

  // ! Open Previous Chat Modal
  fnOpenPreviousChatModal(content: any) {
    this.fnOpenModal(content, {
      centered: true,
      size: 'sm',
      backdrop: "static",
      keyboard: true,
      scrollable: false,
      windowClass: 'rounded-modal'
    });
  }

  // ! Set Session Attributes from Local Storage
  fnContinuePreviousChat() {
    this.messages = this.fnGetPreviousChats();
    this.forceScrollDown();
  }

  fnOpenSmallModal(content: any) {

    // close the uploadFileModel model
    if (this.currentPopover) {
      this.currentPopover.close();
    }

    let options: any = {
      centered: true,
      size: 'sm',
      backdrop: false,
      keyboard: true,
      scrollable: false
    }
    this.currentPopover = this.modalService.open(content, options);
  }

  // **********models close******

  DataPrivacyPolicy(value: boolean) {
    this.canStoreDataToLocalStorage = value;

    if (value) {
      localStorage.setItem("dataPrivacyPolicy", this.encryptionService.encryptData("accepted", "dataPrivacyPolicy"));
      localStorage.setItem("sessionAttributes-" + DATA.clientConfigurationId, this.encryptionService.encryptData(this.sessionAttributes, DATA.clientConfigurationId));
      localStorage.setItem("previousChats-" + DATA.clientConfigurationId, this.encryptionService.encryptData(this.messages, DATA.clientConfigurationId));
    } else {
      localStorage.setItem("dataPrivacyPolicy", this.encryptionService.encryptData("rejected", "dataPrivacyPolicy"));
    }

    this.fnCloseModal();
  }

  imageToBeUploadedBlob = null;
  fnImageUploadedToServer(response: any) {

    this.isTyping = true;

    // alert(serverResponse);
    let serverResponse: any = {};
    if (response) {
      this.imageToBeUploadedBlob = response.imageBlob;
      serverResponse = JSON.parse(response.responseText);
    }
    if (serverResponse.data && serverResponse.data.message) {
      this.stream.getTracks().forEach(function (track: any) {
        track.stop();
      });
      this.fnCloseModal();
    }


    if (response.responseText) {
      ``
      const res = JSON.parse(response.responseText);
      const itemToPush = {
        isUser: false,
        user: 'me',
        text: res?.data?.message,
        info: "",
        info_trimmed: "",
        isGoogleMap: "",
        isTrimmed: false,
        timestamp: this.fnGetDate(),
        isNotEnglish: true,
        widgetType: "input_message"
      }

      this.messages.push(itemToPush);

      this.handleStoreChatToLocalStorage(itemToPush)
      this.isTyping = false;
      this.forceScrollDown();
    }
  }

  startTyping() {
    this.isTyping = true;
    this.forceScrollDown();

  }


  /*******Live Chat Code Start */
  session: any;
  isLiveChat = false;
  customerName = "";
  isAgentTyping = false;
  isInitialisingLiveChat = false;
  transcriptEmail = "";
  transcripts: any[] = [];
  agentInfoId: any = "";
  agentRatingButton: boolean = false;

  fnInitLiveChat() {

    // checking for live chat enabled or not
    if (this.isLiveChat == true) {
      this.fnEndChat();
      const dataToPush = {
        isUser: true,
        user: 'me',
        text: "Live chat ended",
        info: "",
        info_trimmed: "",
        isGoogleMap: "",
        isTrimmed: false,
        timestamp: this.fnGetDate(),
        isNotEnglish: true,
        widgetType: "input_message"
      }
      this.messages.push(dataToPush);
      this.handleStoreChatToLocalStorage(dataToPush)
      return;
    }

    this.isLiveChat = true;
    this.forceScrollDown();
    this.isInitialisingLiveChat = true;

    let that = this;
    let customerName = that.customerName;
    var contactFlowId = DATA.LiveChatContactFlowId;
    var instanceId = DATA.LiveChatInstanceId;
    var apiGatewayEndpoint = DATA.LiveChatBackendURL;
    connect.ChatSession.setGlobalConfig({
      region: DATA.LiveChatRegion
    });

    let initiateChatRequest = {
      Attributes: {
        customerName: customerName
      },
      Username: customerName,
      ParticipantDetails: {
        DisplayName: customerName
      },
      ContactFlowId: contactFlowId,
      InstanceId: instanceId
    };

    this.http.post(apiGatewayEndpoint, initiateChatRequest)
      .toPromise().then(function (result: any) {
        that.session = connect.ChatSession.create({
          chatDetails: result.data.startChatResult,
          type: "CUSTOMER"
        });
        that.session.connect()?.then(async (response: any) => {

          console.log("response***", response);

          let agentTranscripts = that.fnGetChatTranscriptForAgent();
          for (let i = 0; i < agentTranscripts.length; i++) {
            await that.session.controller.sendMessage({
              message: agentTranscripts[i],
              contentType: "text/plain"
            })
          }

          const itemToPush = {
            isUser: false,
            user: 'me',
            text: "Thanks " + customerName + " Please wait for an agent to respond",
            info: "",
            info_trimmed: "",
            isGoogleMap: "",
            isTrimmed: false,
            timestamp: that.fnGetDate(),
            isNotEnglish: true,
            widgetType: "input_message"
          }
          that.messages.push(itemToPush);
          that.forceScrollDown();
          that.handleStoreChatToLocalStorage(itemToPush)


          that.isInitialisingLiveChat = false;
          return response;
        }, (error: any) => {
          return Promise.reject(error);
        });

        that.session.onConnectionEstablished((data: any) => {
          console.log("Recoived data", data)
          console.log("Recoived data ", that.session);

        })

        that.session.onMessage((message: any) => {
          if (message && message.data.ContentType == "application/vnd.amazonaws.connect.event.participant.joined" && message.data.ParticipantRole == "AGENT") {

            let params = {
              clientId: DATA.clientConfigurationId,
              startCnvTime: message.data.AbsoluteTime,
              agentName: message.data.DisplayName,
              customerName: customerName
            }

            console.log("params****", params);

            const itemToPush = {
              isUser: false,
              user: 'me',
              text: customerName + ", you are now connected with " + message.data.DisplayName + " You can start the conversation",
              info: "",
              info_trimmed: "",
              isGoogleMap: "",
              isTrimmed: false,
              timestamp: that.fnGetDate(),
              isNotEnglish: true,
              widgetType: "input_message"
            }
            that.messages.push(itemToPush);
            that.forceScrollDown();
            that.handleStoreChatToLocalStorage(itemToPush)

            that.saveAgentInfo(params);
          }

          if (message && message.data && message.data.ParticipantRole == "AGENT" && message.data.Content) {
            that.isAgentTyping = false;
            const itemToPush = {
              isUser: false,
              user: 'me',
              text: message.data.Content,
              info: "",
              info_trimmed: "",
              isGoogleMap: "",
              isTrimmed: false,
              timestamp: that.fnGetDate(),
              isNotEnglish: true,
              widgetType: "input_message"
            }
            that.messages.push(itemToPush);

            that.forceScrollDown();
            //Support for local storage
            that.handleStoreChatToLocalStorage(itemToPush)
          }
          that.forceScrollDown();
          if (message && message.data && message.data.ContentType) {
            if (message.data.ContentType == "application/vnd.amazonaws.connect.event.chat.ended" && message.data.Type == "EVENT" && that.isLiveChat) {
              that.liveChatEndTime = message.data.AbsoluteTime;
              let params = {
                agentInfoId: that.agentInfoId,
                endCnvTime: message.data.AbsoluteTime,
              }
              that.updateAgentInfo(params);
              that.isAgentTyping = false;
              const itemToPush = {
                isUser: false,
                user: 'me',
                text: "Welcome back " + customerName + ", Hope you had a great conversation with our live agent It will be great if you can please provide a feedback for the conversation with our agent",
                info: "",
                info_trimmed: "",
                isGoogleMap: "",
                isTrimmed: false,
                timestamp: that.fnGetDate(),
                isNotEnglish: true,
                widgetType: "input_message"
              }
              that.messages.push(itemToPush);
              that.forceScrollDown();
              //Support for local storage
              that.handleStoreChatToLocalStorage(itemToPush)

              that.fnEndChat();
              that.agentRatingButton = true;



            }

          }

        });
        that.forceScrollDown();
        that.session.onTyping((typingEvent: any) => {
          if (typingEvent.data.ParticipantRole === "AGENT") {
            that.isAgentTyping = true;
          }
        });

        that.session.onConnectionBroken((data: any) => {
          console.log("Connection broken");
        });
      })
  }
  fnEndChat() {
    this.isLiveChat = false;
    this.session.controller.disconnectParticipant();
    this.fnSetSessionAttributes(false)

    this.isTyping = true;

    setTimeout(() => {
      const itemToPush = {
        isUser: false,
        user: 'me',
        text: "",
        info: "",
        info_trimmed: "",
        isGoogleMap: "",
        isTrimmed: false,
        timestamp: this.fnGetDate(),
        isNotEnglish: true,
        widgetType: "input_message_feedback_with_message_widget"
      }
      this.messages.push(itemToPush);
      this.forceScrollDown();
      //Support for local storage
      this.handleStoreChatToLocalStorage(itemToPush)
      this.isTyping = false;
      this.isAskingForAgentFeedbackStarRating = true;
    }, 2000);

  }

  dissConnectChat() {
    let that = this;
    let customerName = that.customerName;
    that.isAgentTyping = false;
    const itemToPush = {
      isUser: false,
      user: 'me',
      text: "Welcome back " + customerName + ", Hope you had a great conversation with our live agent It will be great if you can please provide a feedback for the conversation with our agent",
      info: "",
      info_trimmed: "",
      isGoogleMap: "",
      isTrimmed: false,
      timestamp: that.fnGetDate(),
      isNotEnglish: true,
      widgetType: "input_message"
    }
    that.messages.push(itemToPush);
    that.forceScrollDown();
    //Support for local storage
    that.handleStoreChatToLocalStorage(itemToPush)

    that.fnEndChat();
    that.agentRatingButton = true;
    that.isLiveChat = false;
  }

  saveAgentInfo(agentparams: any) {
    let that = this;
    let url = "https://lkgx3whm57.execute-api.us-east-1.amazonaws.com/Prod/createagentinfo"
    that.http.post(url, agentparams)
      .toPromise().then(function (result: any) {
        let datttt = JSON.stringify(result);
        that.agentInfoId = datttt;
      })
  }
  updateAgentInfo(agentparams: any) {
    let url = "https://lkgx3whm57.execute-api.us-east-1.amazonaws.com/Prod/updateAgentInfo"
    this.http.post(url, agentparams)
      .toPromise().then(function (result: any) {

      })
  }

  /** Live Chat code end */

  handleFeedBackSubmit(event: any) {
    this.isFeedbackSubmitted = true;
  }

  downloadingPdf = false;
  generatePdf() {
    this.downloadingPdf = true;
    const data = document.getElementById('conversationContent');
    const originalHeight = data!.style.height;
    const originalOverflow = data!.style.overflow;

    // Temporarily expand the content to its full height
    data!.style.height = 'auto';
    data!.style.overflow = 'visible';

    html2canvas(data!, { scale: 2 }).then(canvas => {  // Reduced scale for smaller file size
      const imgWidth = 210; // A4 width in mm
      const pageHeight = 297; // A4 height in mm
      const imgHeight = canvas.height * imgWidth / canvas.width;
      let heightLeft = imgHeight;

      const pdf = new jsPDF('p', 'mm', 'a4');
      let position = 0;

      // Add the image with compression
      pdf.addImage(canvas.toDataURL('image/jpeg', 0.8), 'JPEG', 0, position, imgWidth, imgHeight); // Changed to JPEG with compression
      heightLeft -= pageHeight;

      while (heightLeft >= 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(canvas.toDataURL('image/jpeg', 0.8), 'JPEG', 0, position, imgWidth, imgHeight); // Changed to JPEG with compression
        heightLeft -= pageHeight;
      }

      pdf.save('conversation.pdf');

      // Restore the original height and overflow properties
      data!.style.height = originalHeight;
      data!.style.overflow = originalOverflow;

      setTimeout(() => {
        this.forceScrollDown();
      }, 200);

      this.downloadingPdf = false;
    });
  }



  // ! Force to Scroll down on each new message
  public forceScrollDown(): void {
    if (this.chatWindowRef !== undefined) {
      setTimeout(() => {

        this.chatWindowRef.nativeElement.scrollTop = this.chatWindowRef?.nativeElement.scrollHeight;

      }, 100);
    }

    this.cdr.detectChanges();
  }

  // ! Adding delay in Chat Response
  private fnAddDelayedChatMessage(chatMessage: any, i: any, textData: any, isGenericCard: any, israting = false) {
    console.log("chatMessage", chatMessage);
    let that = this;
    setTimeout(() => {
      that.messages.push(chatMessage);
      //Support for cookies
      if (!israting) {
        this.handleStoreChatToLocalStorage(chatMessage)
      }

      if (i == textData.length - 1 && !isGenericCard) {
        that.isTyping = false;
      }
      that.forceScrollDown();
    }, that.chatDelayInterval);
  }

  // ! Start User Idle Timer (to Notice User Inactivity)
  private fnStartUserIdleTimer() {
    let that = this;
    this.userTimeoutFunction = setTimeout(() => {
      that.isUserIdleTimeoutExpired = true;
    }, that.userIdleTimeout);
  }

  // ! Reset User Idle Timer
  private fnResetUserIdleTimer() {
    if (this.userTimeoutFunction) {
      clearTimeout(this.userTimeoutFunction);
    }
    this.fnStartUserIdleTimer();
  }

  public fnGetChatTranscriptForAgent() {
    let agentTranscripts = ["****Chat Start****"];

    for (let i = 0; i < this.transcripts.length; i++) {
      agentTranscripts.push("[**User: " + this.transcripts[i].inputTranscript + " **]"
        + "      [**Bot: " + this.transcripts[i].botResponse + " **]");
    }

    agentTranscripts.push("****Chat Ended****");
    return agentTranscripts;

  }
  fileName: string | null = null;
  base64Data: string | null = null;
  isPdfLoading = false;
  private subscription: Subscription = new Subscription;
  statusMessage: string | null = null;

  @ViewChild('fileInput') fileInput: any;


  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    if (event.dataTransfer?.files.length) {
      this.handleFile(event.dataTransfer.files[0]);
    }
  }

  onFileSelected(event: Event) {
    const file = (event.target as HTMLInputElement).files?.[0];
    if (file) {
      this.handleFile(file);
    }
  }

  handleFile(file: File) {
    this.fileName = file.name;
    const reader = new FileReader();
    reader.onload = (e: any) => {
      this.base64Data = this.convertToBase64(e.target.result);
    };
    reader.readAsDataURL(file);
  }

  convertToBase64(pdf: string): string {
    return pdf.split(',')[1]; // Remove the Data URL prefix
  }

  removePDF() {
    this.fileName = null;
    this.base64Data = null;
  }


  checkStatus(intent_name: any): void {
    let param = {
      userInput: intent_name,
      botAlias: 'pdfchatagent',
      sessionAttributes: {
        ORGANIZER_TIMEZONE: 'Asia/Calcutta',
        leadChannel: 'tina',
        pdf_id: this.pdf_id,
        is_pdf_chat: 'false',
        registrationChannel: 'tina',
        CleintId: 'a0a41f56-be29-40dc-b782-3214acf40ae6'
      },
      features: {
        authorization: false,
        intent_detection: false,
        translation: false,
        sentiment_analysis: false,
        sentiment_bth: false,
        object_description: false,
        google_translate: false,
        email_attachment: false,
        preferred_language: 'en'
      },
      image: null
    };

    this.subscription = interval(2000)
      .pipe(
        switchMap(() => {
          return this.messageService.getSetMessages(param);
        }),
        tap(response => {
          console.log('API response:', response);
        }),
        takeWhile(response => {
          const isCompleted = response?.body?.message !== 'completed';
          console.log('Current status:', response?.body?.message, 'Continue polling:', isCompleted);
          return isCompleted;
        }, true)
      )
      .subscribe(
        response => {
          if (response?.body?.message === 'completed') {
            this.statusMessage = 'Status completed!';
            this.subscription.unsubscribe();
            this.triggerIntent('query');
          } else {
            this.statusMessage = 'Status: Processing...';
          }
        },
        error => {
          console.error('Error occurred:', error); // Log the error
          this.statusMessage = 'Error occurred: ' + error.message;
        }

      );
  }


  triggerIntent(intentName: any): void {

    let param = {
      "userInput": intentName,
      "botAlias": "pdfchatagent",
      "sessionAttributes": this.sessionAttributes,
      "features": {
        "authorization": false,
        "intent_detection": false,
        "translation": false,
        "sentiment_analysis": false,
        "sentiment_bth": false,
        "object_description": false,
        "google_translate": false,
        "email_attachment": false,
        "preferred_language": "en"
      },
      "image": null
    }

    this.http.post("https://jv1ie3n7cg.execute-api.us-east-1.amazonaws.com/dev/feature-api-extended",
      param
    )
      .subscribe(
        data => {
          this.statusMessage = 'Data received: ' + JSON.stringify(data);

          const itemToPush = {
            isUser: false,
            user: 'me',
            text: "PDF processing is complete. You can now ask questions about the document.",
            info: "",
            info_trimmed: "",
            isGoogleMap: "",
            isTrimmed: false,
            timestamp: this.fnGetDate(),
            isNotEnglish: true,
            widgetType: "input_message"
          }

          this.messages.push(itemToPush);
          this.forceScrollDown();
          this.handleStoreChatToLocalStorage(itemToPush)
        },
        error => {
          this.statusMessage = 'Error fetching data: ' + error.message;
        },

        () => {
          this.isTyping = false;
        }

      );
  }

  submitPDF() {
    if (this.base64Data) {
      console.log('Submitting PDF:', this.base64Data);
      this.isPdfLoading = true;
      const url = "https://v43lof3n6vycvl5ogtxkvwmjni0cmgds.lambda-url.us-east-1.on.aws/"
      let that = this;


      this.fnCloseModal();
      this.isTyping = true;
      const headers = new HttpHeaders({
        'Content-Type': 'text/plain'
      });

      const param = {
        "pdf_id": "",
        "is_pdf_chat": "false",
        "fileName": this.fileName,
        "client_id": "a0a41f56-be29-40dc-b782-3214acf40ae6",
        "file": this.base64Data,
      };


      this.removePDF();

      this.http.post('https://v43lof3n6vycvl5ogtxkvwmjni0cmgds.lambda-url.us-east-1.on.aws', param, { headers })
        .subscribe((res: any) => {
          console.log(res);
          if (res) {
            this.pdf_id = res.pdf_id;
            this.sessionAttributes = {
              ...this.sessionAttributes,
              pdf_id: this.pdf_id
            }

            this.isPdfLoading = false;


            const itemToPush = {
              isUser: false,
              user: 'me',
              text: "I'm processing your PDF. Please wait as this will give me a better understanding to answer your queries.",
              info: "",
              info_trimmed: "",
              isGoogleMap: "",
              isTrimmed: false,
              timestamp: that.fnGetDate(),
              isNotEnglish: true,
              widgetType: "input_message"
            }

            this.messages.push(itemToPush);
            this.forceScrollDown();
            this.handleStoreChatToLocalStorage(itemToPush)

            this.checkStatus("notify_pdf_processing_complete");
          }
        }, error => {
          console.error(error);
          this.isPdfLoading = false;
        }
        );
    }
  }

  closeChat() {
    console.log('Closing chat');
    // Send a message to the parent window to close the chat
    window.parent.postMessage('closeChatBot', '*');
    // window.opener.postMessage('Message to the parent', "*");
  }
}
